import styled from "styled-components";
import { viewSizes } from "./variables";

export const FormWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 7rem auto;
  width: 50%;

  @media only screen and (max-width: ${viewSizes.tablet}) {
    width: 90%;
  }

  & > .uidInfo {
    display: flex;
    justify-content: space-between;
    /* width: 33%; */
    width: 100%;
  }
`;

// input
export const InputWrapper = styled.input`
  background-color: #f3f6fc;
  padding: 2rem;
  border: 2px solid #d6e3f0;
  width: 100%;
  margin: 0.6rem 0 3rem 0;
  font-size: 1.5rem;

  &::placeholder {
    text-align: center;
    font-size: 2.5rem;
  }

  &:focus {
    outline: none;
  }
`;

export const LabelWrapper = styled.label`
  color: #1a284f;
  align-self: baseline;
  font-size: 2.8rem;
  font-weight: bold;
`;

// 계정 UID 확인 방법 텍스트
export const SpanWrapper = styled.span`
  color: #00a4e1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: bold;

  /* 물음표 아이콘 */
  & > svg {
    width: 2rem;
    /* align-self: baseline; */
    margin-top: -0.2rem;
  }
`;

export const InfoWrapper = styled.ul`
  margin: 5rem 0 2rem 0;

  & > li {
    text-align: left;
    font-size: 1.6rem;
  }
`;
export const BtnWrapper = styled.img`
  cursor: pointer;
  /* width: 80%; */
`;
